<template>
	<section class="page">
		<div>
			<h2>{{info.brand}} - {{info.name}}</h2>
		</div>
		<el-tabs v-model="activeName" v-loading="loadings.dm">
			<el-tab-pane label="基础信息" name="info">
				<Active-base-info
					v-if="activeName=='info'"
					:dataModel="dataModel"
					:record-id="id"
					class="content-box"
					@change="handleEdited($event)"
					:table-data-model="dataModels[dataModel]"
					:has-get-table-data-model="hasGetTableDataModel"
					:value="info"
				></Active-base-info>
			</el-tab-pane>
			<el-tab-pane label="预约情况" name="items">
				<div v-if="activeName=='items'">
					<booking-info
						:dataModel="dataModel"
						:record-id="id"
						@change="handleEdited($event)"
						:table-data-model="dataModels[dataModel]"
						:has-get-table-data-model="hasGetTableDataModel"
						:value="info"
						v-if="hasLoadData"
					></booking-info>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import ActiveBaseInfo from "@/views/Active/subs/ActiveBaseInfo.vue";
import BookingInfo from "@/views/Active/subs/BookingInfo.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import TabPage from "@/mixins/TabPage.js";

export default {
	mixins: [TabPage],
	components: {
		ActiveBaseInfo,
		BookingInfo,
	},
	data() {
		return {
			loadings: {
				main: false,
				dm: false,
				create: false,
			},
			activeName: "info",
			hasLoadData: false,

			info: {
				brand: "",
			},
			styles: [],
			visible: false,
			dataModel: "Active",
			id: "",
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM"]),
		hasGetTableDataModel() {
			if (this.dataModels[this.dataModel] && this.dataModels[this.dataModel]._id) {
				return true;
			} else {
				return false;
			}
		},
	},
	created() {},
	mounted() {
		this.refreshDataModel();
		this.refreshData();
	},
	methods: {
		...mapMutations(["checkDataModel"]),
		refreshDataModel() {
			this.checkDataModel(this.dataModel);
		},
		refreshData() {
			this.id = this.$route.params.id;
			this.loadings.main = true;

			this.$axios
				.post(`/curd/edit/${this.dataModel}/${this.id}`)
				.then(json => {
					this.loadings.main = false;
					for (let k in json.data.info) {
						this.$set(this.info, k, json.data.info[k]);
					}
					this.hasLoadData = true;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: "refreshData",
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					// this._refreshRules();
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
